import { routes } from "utils/routes"
import { ShopKeeperLayout } from "views/layouts"
import EmployeeLayout from "views/layouts/employee"
import { ForgotPassword, Login, ResetPassword } from "views/pages/auth"

const PublicRoutes = [
  { path: `${routes.login}`, exact: true, name: 'Login', component: Login },
  { path: `${routes.resetPassword}`, exact: true, name: 'Reset password', component: ResetPassword },
  { path: `${routes.forgotPassword}`, exact: true, name: 'Forgot password', component: ForgotPassword },
  { path: `${routes.employeeLayout}`, exact: true, name: 'EmployeeLayout', component: EmployeeLayout },
  { path: `${routes.shopkeeperLayout}`, exact: true, name: 'shopkeeper', component: ShopKeeperLayout },
]

export default PublicRoutes